import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-03/task-02";

const task: Slide = {
  description: "Select true statesments:",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
